<app-navtop></app-navtop>

<div class="container-fluid pt-5">
    <div class="d-flex flex-row bd-highlight"> 
        <div class="col-xl-8 col-lg-8 col-md-10  p-2 mx-xl-auto mx-lg-auto mx-md-auto content-main">
            <div class="card mx-auto border-0 shadow-lg">
                <img [src]="coverPhoto" class="card-img-top cover-photo" alt="...">
            </div>
        </div>
    </div>
</div>